import { Box, IconButton } from '@mui/material';
import CustomText from 'components/common/CustomText/CustomText';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import EditProfileDialog from '../EditProfileDialog/EditProfileDialog';
import { ProfileProvider } from 'context/ProfileContext';

interface Props {
  handleClose: () => void;
}

export default function EditProfileButton(props: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const globalStyles = useGlobalStyles();


  const handleEditClick = () => {
    setOpen(true);
  }

  return (
    <ProfileProvider>

      <IconButton
        onClick={handleEditClick}
        className={globalStyles.popoverButtonContainer}
      >
        <Box className={globalStyles.popoverIconContainer}>
          <EditIcon sx={{ color: colors.black, fontSize: 20 }} />
        </Box>
        <CustomText text="Edit personal info" ml="5px" color={colors.black} />
      </IconButton>

      <EditProfileDialog
        {...props}
        open={open}
        setOpen={setOpen}
      />
    </ProfileProvider>
  )
}
